<!--<h1 class="p-text-center p-text-secondary">-->
<!--    Shipment Roles-->
<!--</h1>-->
<!--&lt;!&ndash;<div class=" p-d-lg-flex p-jc-lg-center">&ndash;&gt;-->
<!--&lt;!&ndash;    <div class="p-grid user-roles-center-align p-jc-between">&ndash;&gt;-->
<!--&lt;!&ndash;        <div *ngFor="let roles of userRoles " class="p-col-12 p-lg-2">&ndash;&gt;-->
<!--&lt;!&ndash;            <div [class]="roles === selectedRole  ? 'backgroundWhenSelected  card' :&ndash;&gt;-->
<!--&lt;!&ndash;                ' card '" (click)="onClickUpdateRoles(roles)">&ndash;&gt;-->
<!--&lt;!&ndash;                {{roles}}&ndash;&gt;-->
<!--&lt;!&ndash;            </div>&ndash;&gt;-->
<!--&lt;!&ndash;        </div>&ndash;&gt;-->
<!--&lt;!&ndash;    </div>&ndash;&gt;-->
<!--&lt;!&ndash;</div>&ndash;&gt;-->

<!--<div class="outerBox">-->
<!--    &lt;!&ndash;    <div class="p-grid user-roles-center-align p-jc-between">&ndash;&gt;-->
<!--    <div *ngFor="let roles of userRoles " class="p-col-12 p-lg-2 p-mx-lg-5 p-mx-0">-->
<!--        <div [class]="selectedRoles?.includes(roles)  ? 'backgroundWhenSelected'  :-->
<!--                'card '">-->
<!--            <div class="check-box-position">-->
<!--                <p-checkbox (onChange)="storeSelectedShippingRoles($event)" name="group1" value="{{roles}}"-->
<!--                            [(ngModel)]="selectedRoles" inputId="ny"></p-checkbox>-->
<!--            </div>-->
<!--            {{roles}}-->

<!--        </div>-->
<!--    </div>-->
<!--    &lt;!&ndash;    </div>&ndash;&gt;-->
<!--    &lt;!&ndash;    <div class="card">Inner Box</div>&ndash;&gt;-->
<!--</div>-->
<div class="p-text-center p-text-secondary sticky-header">
    <h3 class="p-m-0">Shipping Roles</h3>
</div>
<!--<div class="center-content">-->
<!--    <div class="p-d-flex p-jc-between p-ai-center">-->
<!--        <div class="p-col-12 p-lg-3 p-xl-2" *ngFor="let role of shippingRoles">-->
<!--            <div>-->

<!--            </div>-->
<!--            <div>-->
<!--                <div class="check-box-position">-->
<!--                    <p-checkbox (onChange)="storeSelectedShippingRoles($event)" name="shippingRoles" value="{{role}}"-->
<!--                                [(ngModel)]="selectedShippingRoles"></p-checkbox>-->
<!--                </div>-->
<!--                <div class="card shipping-roles-card">-->
<!--                    {{role}}-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--    </div>-->
<!--</div>-->

<div class="center-content">
    <div class="p-grid p-jc-center p-ai-center">
        <div class="p-col-12 p-lg-3 p-xl-2" *ngFor="let role of shippingRoles">
            <div class="card shipping-roles-card">
                {{role}}
            </div>
        </div>
    </div>
</div>
